<template>
  <div class="active_detial">
    <div :class="['teachingActivity', { 'discussion-activity': query.type === 5 }]">
      <div class="header" v-if="Number(query.type) !== 6">
        <div class="header_left">
          <span class="zhangjie"> {{ query.zhangName }} / {{query.jieName }}</span>
          <span class="name">{{ query.name }}</span>
          <div class="countDown">
            <span style="color:#FD8C41" v-if="query.status==0">已结束</span>
            <span v-else>
              <span style="color:#FD8C41">{{countdown}}</span>
              <span style="color:#FD8C41" v-if="query.duration===0">无限制</span>
            </span>
          </div>
        </div>
        <div class="button_box">

          <el-button class="back_button" @click="goBack">返回</el-button>
          <el-button style="background: #fff;color: #666;" v-if="(query.type==2 && !voteDetial.has_voted) && query.status!=0 && countdown!='已结束'" class="back_button" @click="submit">提交</el-button>
        </div>
      </div>
      <div class="content" :class="Number(query.type) === 6 ? 'h-full' : ''">
        <!-- 签到 -->
        <div class="content_box" v-if="query.type==1">
          <div class="sign_button">
            <div class="circle" v-if="!checkinObject.create_time" @click="checkin">签到</div>
            <div class="icon" v-if="checkinObject.create_time"><i class="el-icon-success"></i></div>
            <div class="tip" v-if="checkinObject.create_time">签到成功</div>
            <div class="time" v-if="checkinObject.create_time">{{ checkinObject.create_time }}</div>
          </div>
        </div>
        <!-- 投票 -->
        <div class="content_box" v-if="query.type==2">
          <div class="selectlist">
            <div :class="['list_item',{'active_list_item':item.option_text==voteDetial.selected_option}]" v-for="item in voteDetial.options" @click="activeOption(item)">{{ item.option_text }}</div>
          </div>
        </div>
        <!-- 选人 -->
        <div class="content_box" v-if="query.type==3">
          <div class="selectCard">
            <div class="header1" v-if="selectPeopleName.s_name"><img src="../../../assets/img/image/random.png" alt="">随机选人</div>
            <div class="selectPeople">
              <img v-if="!selectPeopleName.s_name" src="../../../assets/img/image/select_bgc.png" alt="">
              <span v-if="!selectPeopleName.s_name" style="margin-top: 20px;color: #999;">老师暂无选人</span>
              <span v-else style="color: #333;font-weight: 700;font-size: 54px;">{{ selectPeopleName.s_name }}</span>
            </div>
          </div>
        </div>
        <!-- 抢答 -->
        <div class="content_box" v-if="query.type==4">
          <div class="sign_button" v-if="isRush===false">
            <div class="circle" @click="rushAnswer">抢答</div>
          </div>
          <div class="rush_list" v-if="isRush===true">
            <div class="title"><img src="../../../assets/img/image/title.png" alt="">抢答结果</div>
            <div class="list_box">
              <div class="list_item" v-for="(item,index) in rushAnswerList">
                <div class="sort">
                  <img v-if="index==0" src="../../../assets/img/image/number1.png" alt="">
                  <img v-else-if="index==1" src="../../../assets/img/image/number2.png" alt="">
                  <img v-else-if="index==2" src="../../../assets/img/image/number3.png" alt="">
                  <span v-else>{{ index+1 }}</span>
                </div>
                <div class="avator">
                  <img v-if="!item.student.s_ico" src="../../../assets/images/user_img.png" alt="">
                  <img v-else :src="item.student.s_ico" alt="">
                </div>
                <div class="info">
                  <div>{{ item.student.s_name }}</div>
                  <div class="timer">抢答时间:{{ item.student.timer }}</div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <!-- 主题讨论 -->
        <ThematicDiscussionDetial v-if="query.type==5"></ThematicDiscussionDetial>

        <!-- 随堂练习 -->
          <class-exercise-paper v-if="Number(query.type) === 6"></class-exercise-paper>
      </div>
    </div>
  </div>
</template>

<script>
import ThematicDiscussionDetial from "@/components/teacherCourse/component/ThematicDiscussionDetial.vue";
import WsConfig from "@/utils/wsConfig";
import { sendWsData } from "@/utils/utils";
import ClassExercisePaper from "@/components/Student/course/ClassExercisePaper.vue";
export default {
  components: {
      ClassExercisePaper,
    ThematicDiscussionDetial,
  },
  data() {
    return {
      countdown: "",
      query: {
        type: void 0,
      },
      hideButton: true,
      checkinObject: {
        create_time: "",
      },
      rushAnswerList: [],
      isRush: void 0,
      selectPeopleName: {
        s_name: "",
      },
      voteDetial: {
        has_voted: false,
        selected_option: "",
        options: [],
      },
      activeId: void 0,
      wsIns: null,
      wsTimer: null,
    };
  },
  created() {
    this.websocketInit();
    this.query = JSON.parse(localStorage.getItem("query"));
    this.query.zhangName = this.query.zhangName
      ? this.query.zhangName
      : localStorage.getItem("zhangName");
    this.query.jieName = this.query.jieName
      ? this.query.jieName
      : localStorage.getItem("jieName");

    if (this.query.duration != 0 && this.query.type != 6) {
      this.getCountdown(this.query.create_time, this.query.duration);
    }
    if (this.query.type == 1) {
      this.$nextTick(() => {
        this.getCheckinDetial();
      });
    }
    if (this.query.type == 2) {
      this.$nextTick(() => {
        this.getVoteDetial();
      });
    }
    if (this.query.type == 3) {
      this.$nextTick(() => {
        this.getselectPeopleName();
      });
    }
    if (this.query.type == 4) {
      this.$nextTick(() => {
        this.getRushAnswerDetial();
      });
    }
  },
  methods: {
    websocketInit() {
      this.wsIns = new WebSocket(WsConfig.url);
      this.wsIns.onopen = () => {
        this.wsIns.send(sendWsData("bind"));
        if (this.wsTimer) clearInterval(this.wsTimer);
        this.wsTimer = setInterval(() => {
          const sendMsg = sendWsData("ping");
          this.wsIns.send(sendMsg);
        }, 50000);
      };
      this.wsIns.onmessage = (evt) => {
        const data = JSON.parse(evt.data);

        switch (data.type) {
          // 连接成功
          case "connect":
            this.bindClient(data.data.client_id);
            break;
          case "new_act":
            // console.log("收到新活动通知：", data);
            break;
          case "stop_act":
            // console.log("活动停止：", data);
            break;
          case "del_act":
            // console.log("活动删除：", data);
            break;
          case "join_group":
            // console.log("加入班级", data);
            break;
          case "reset_select_person":
            //console.log("重置选人11", data);
            this.getselectPeopleName();
            break;
          case "rand_select_person":
            //console.log("随机选人", data);
            this.getselectPeopleName();
            break;
          default:
          // console.log("收到未知类型消息：", data);
        }
      };
      //断开之后重连
      this.wsIns.onclose = () => {
        console.log("已断开连接，尝试重新连接");
        this.websocketInit();
      };
    },
    // 绑定客户端
    bindClient(client_id) {
      this.$shttp.axiosPost(
        this.$api.jdWsBind,
        { client_id: client_id },
        (res) => {
          if (res.code == 200) {
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getCountdown(create_time, duration1) {
      const startTime = new Date(create_time);
      // 定义倒计时时长（5 分钟，单位：毫秒）
      // duration1 = duration1 == 4 ? duration1 + 1 : duration1;
      const duration = duration1 * 60 * 1000;
      // 计算结束时间
      const endTime = new Date(startTime.getTime() + duration);
      // 初始调用一次更新函数
      this.updateCountdown(endTime);
      // 每秒更新一次倒计时
      this.intervalId = setInterval(() => {
        this.updateCountdown(endTime);
      }, 1000);
    },
    // 更新倒计时的函数
    updateCountdown(endTime) {
      const now = new Date();
      const remainingTime = endTime - now;

      if (remainingTime > 0) {
        const minutes = Math.floor(
          (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

        this.countdown = `剩余${minutes.toString().padStart(2, "0")}分:${seconds
          .toString()
          .padStart(2, "0")}秒`;
      } else {
        this.countdown = "已结束";
        this.hideButton = false;
        clearInterval(this.intervalId);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    Hidebutton() {},
    beforeDestroy() {
      // 组件销毁前清除定时器
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
    checkin() {
      this.$http.axiosPost(
        this.$api.jdSActivitiesCheckinCheckin,
        { id: this.query.id },
        (res) => {
          if (res.code === 200) {
            this.$message("签到成功");
            this.getCheckinDetial();
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getCheckinDetial() {
      this.$http.axiosPost(
        this.$api.jdSActivitiesCheckinInfo,
        { id: this.query.id },
        (res) => {
          if (res.code === 200) {
            if (res.data.length == 0) return;
            this.checkinObject = res.data;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    rushAnswer() {
      this.$http.axiosPost(
        this.$api.jdSActivitiesAnswer_recordAnswer,
        { id: this.query.id },
        (res) => {
          if (res.code === 200) {
            this.$message("抢答成功");
            this.getRushAnswerDetial();
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getRushAnswerDetial() {
      this.$http.axiosPost(
        this.$api.jdSActivitiesAnswer_recordInfo,
        { id: this.query.id },
        (res) => {
          if (res.code === 200) {
            this.rushAnswerList = res.data;
            console.log(this.rushAnswerList, "this.rushAnswerList");

            if (this.rushAnswerList.length > 0) {
              let index = this.rushAnswerList.findIndex(
                (item) =>
                  item.activities_id == this.query.id &&
                  item.student.s_id == localStorage.getItem("s_id")
              );
              if (index != -1) {
                this.isRush = true;
              } else {
                this.isRush = false;
              }
            } else {
              this.isRush = false;
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getselectPeopleName() {
      this.$http.axiosPost(
        this.$api.jdSActivitiesSelect_personInfo,
        { id: this.query.id },
        (res) => {
          if (res.code === 200) {
            this.selectPeopleName.s_name = "";
            if (res.data.length == 0) return;
            // this.checkinObject = res.data;
            this.selectPeopleName.s_name = res.data.student.s_name;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getVoteDetial() {
      this.$http.axiosPost(
        this.$api.jdSActivitiesVoteInfo,
        { id: this.query.id },
        (res) => {
          if (res.code === 200) {
            this.voteDetial.has_voted = res.data.has_voted;
            this.voteDetial.selected_option = res.data.selected_option;
            this.voteDetial.options = res.data.options;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    submit() {
      if (!this.activeId) {
        this.$message.warning("请选择投票选项");
      } else {
        this.$http.axiosPost(
          this.$api.jdSActivitiesVoteAddVote,
          { id: this.query.id, option_id: this.activeId },
          (res) => {
            if (res.code === 200) {
              this.$message.success("投票成功");
              this.getVoteDetial();
            }
          },
          (err) => {
            console.log(err);
          }
        );
      }
    },
    activeOption(item) {
      if (this.query.type == 2 && this.voteDetial.has_voted) return;
      this.activeId = item.id;
      this.voteDetial.selected_option = item.option_text;
      // jdSActivitiesVoteAddVote
    },
  },
};
</script>

  <style scoped lang="scss">
  .h-full {
      height: 100% !important;
  }
.active_detial {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;

  .teachingActivity {
    width: 100%;
    height: 100%;
    background: #fff;

    &.discussion-activity {
      background-color: transparent;

      .header {
        background-color: #ffffff;
        border-bottom: none;
        margin-inline: 20px;
        border-radius: 4px;
      }
    }

    .header {
      height: 60px;
      padding: 0 40px;
      box-sizing: border-box;
      border-bottom: 1px solid #e4e4e4;
      .header_left {
        height: 100%;
        display: flex;
        align-items: center;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 19px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        .zhangjie {
        }
        .name {
          margin: 0 30px;
        }
        .countdown {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #fd8c41;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
      display: flex;
      align-items: center;
      justify-content: space-between;
      .button_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
    .back_button {
      width: 88px;
      height: 36px;
      background: #006eff;
      border-radius: 4px 4px 4px 4px;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.content {
  width: 100%;
  height: calc(100vh - 210px);
  overflow-y: auto;
  padding-bottom: 20px;
  box-sizing: border-box;
  .content_box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .sign_button {
      margin-top: 80px;
      width: 426px;
      padding: 40px 0;
      background: #e5eefe;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border-radius: 8px;
      border: 1px solid #cbdeff;
      .icon {
        font-size: 100px;
        color: #006eff;
      }
      .tip {
        color: #006eff;
        font-size: 18px;
      }
      .time {
        color: #a0a1a5;
        margin-top: 10px;
      }
      .circle {
        width: 180px;
        height: 180px;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #006eff;
        font-size: 40px;
        color: #fff;
      }
    }
    .rush_list {
      .title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 32px;
        color: #000000;
        line-height: 38px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-top: 20px;
        display: flex;
        justify-content: center;
        .img {
          width: 40px;
          height: 40px;
          margin-right: 10px;
        }
      }
      .list_box {
        margin-top: 20px;
        width: 550px;
        max-height: 600px;
        overflow-y: auto;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #dcdcdc;
        .list_item {
          width: 100%;
          height: 68px;
          padding: 0 20px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          border-top: 1px solid #dcdcdc;
          cursor: pointer;
          &:nth-of-type(1) {
            border-top: none;
          }
          &:nth-of-type(2n-1) {
            background: #fafafa;
          }
          .sort {
            width: 30px;
            margin-right: 20px;
            img {
              width: 26px;
              height: 26px;
              object-fit: cover;
            }
          }
          .avator {
            width: 48px;
            height: 48px;
            border-radius: 100%;
            margin-right: 20px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 100%;
            }
          }
          .info {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #333333;
            line-height: 19px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            .timer {
              color: #999999;
              margin-top: 5px;
            }
          }
        }
      }
    }
    .selectCard {
      margin-top: 50px;
      width: 426px;
      // height: 200px;
      // background: skyblue;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .header1 {
        margin-bottom: 20px;
        font-size: 22px;
        display: flex;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 32px;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;
        align-items: center;
        img {
          width: 32px;
          height: 32px;
          margin-right: 10px;
        }
      }
      .selectPeople {
        width: 426px;
        height: 263px;
        background: #f9f9f9;
        border-radius: 12px 12px 12px 12px;
        border: 1px solid #e8e8e8;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }
      .button {
        display: flex;
        .el-button {
          width: 185px;
          height: 38px;
          background: #006eff;
          border-radius: 8px 8px 8px 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
        }
      }
    }
    .selectlist {
      width: 100%;
      display: flex;
      // justify-content: center;
      align-items: center;
      flex-direction: column;

      .list_item {
        width: 780px;
        height: 60px;
        background: #f4f5fe;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 12px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 18px;
        color: #3a4b7d;
        line-height: 28px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
      }
      .active_list_item {
        background: #006eff;
        color: #fff;
      }
    }
  }
}
/* 设置滚动条整体 */
::-webkit-scrollbar {
  width: 4px; /* 滚动条宽度 */
  height: 6px; /* 水平滚动条高度 */
}

/* 设置滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1; /* 轨道背景色 */
}

/* 设置滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #c1bfbf; /* 滑块背景色 */
  border-radius: 10px; /* 滑块圆角 */
}

/* 设置滚动条滑块悬停时的样式 */
::-webkit-scrollbar-thumb:hover {
  background: #b3b2b2; /* 滑块悬停背景色 */
}
</style>
